export const PARTNER_FIDMARQUES_ID = 9
export const PARTNER_SCANOBAR_ID = 42
